import { SVGProps } from 'react';

function CalendarArrowRight(props: SVGProps<SVGSVGElement>) {
    return (
       <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="20" 
            height="20" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="1" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            className="lucide lucide-calendar-arrow-right"
            {...props}
        >
            <path d="m18 14 4 4-4 4"/>
            <path d="M16 2v4"/>
            <path d="M14 18h8"/>
            <path d="M21 11.354V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.343"/>
            <path d="M3 10h18"/>
            <path d="M8 2v4"/>
        </svg>
    );
}

export default CalendarArrowRight;
